function getUTC() {
  const data = new Date();
  const offsetMinutes = data.getTimezoneOffset();
  const offsetHours = -offsetMinutes / 60;

  const sign = offsetHours >= 0 ? "+" : "-";
  const absoluteHours = Math.abs(Math.floor(offsetHours));

  const formattedHours = String(absoluteHours).padStart(2, "0");

  return `${sign}${formattedHours}:00`;
}

export { getUTC };
